<template>
  <svg
    class="va-icon-vuestic"
    :height="height"
    viewBox="0 0 690 60"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    @click="goHomePage"
  >
    <text
      x="0"
      y="50"
      class="title-top"
      style="
        width: 100%;
        font-size: 40px;
        font-weight: 700;
        fill: rgba(0, 0, 0, 1);
      "
    >
      东风日产数字员工全生命周期管理系统
    </text>

    <defs>
      <linearGradient
        id="paint0_linear"
        x1="0"
        y1="56.1386"
        x2="357.64"
        y2="56.1386"
        gradientUnits="userSpaceOnUse"
      >
        <stop :stop-color="colorsComputed.end" />
        <stop offset="1" :stop-color="colorsComputed.start" />
      </linearGradient>
    </defs>
  </svg>

</template>
<script>
import { useColors } from "vuestic-ui";
import VXETable from "vxe-table";
import Qs from "qs";

export default {
  name: "VaIconVuesticNoNotice",
  components: {

  },
  props: {
    height: { type: [Number, String], default: 30 },
    color: { type: [String], default: "primary" },
  },
  data() {
    return {
      noticeTitle: "",
      isShow: false,
      title: "公告",
      text: "",
    };
  },
  computed: {
    colorsComputed() {
      const { getColor, shiftHSLAColor } = useColors();
      const color = getColor(this.color, "primary");

      return { start: color, end: shiftHSLAColor(color, { l: -20 }) };
    },
  },
  methods: {
    showMore() {
      this.isShow = true;
    },
    showText() {
      const quill = this.$refs.quill;
      quill.setHTML(this.text);
    },
    goHomePage() {
      this.$router.push({ path: "/" });
    },
  }
};
</script>

<style scoped>
.notice-box {
  width: 500px;
  height: 100%;
  overflow: hidden;
  margin-left: 20px;

  /* 改成行内 */
  display: inline-block;
}
.scrollText {
  animation: marquee 20s linear infinite;
  color: rgba(212, 48, 48, 1);
  font-size: 18px;
  white-space: nowrap;
  vertical-align: bottom;
}

@keyframes marquee {
  from {
    transform: translateX(100%);
  }
  to {
    transform: translateX(-100%);
  }
}
</style>
